import {
	Configuration,
	ContractApi,
	ContractDownloadDto,
	DownloadContractRequest,
	FascicoloDto,
	GenerateContractRequest,
	GetIdentificationUrlRequest,
	IdentificationRequest,
	IdentificationiResponseDto,
	IntesiLinkResponse,
	IntesiPushOtpResponse,
	IntesiResponseDto,
	PushOtp1Request,
	SelfLoginRequest,
	SignContractRequest,
	SumsubTokenResponse,
} from "@api/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FilesUtils } from "common/file.utils";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { decodeError, errorHandler } from "core/store/config";

enum ContractReducer {
	getIdentificationUrl = "[CONTRACT] Get identification url",
	identification = "[CONTRACT] Identification",
	generateContracts = "[CONTRACT] Generate Contracts",
	downloadContract = "[CONTRACT] Download Contract",
	signContract = "[CONTRACT] Sign Contract",
	sumsubLogin = "[CONTRACT] Sumsub Login",
	selfIdentification = "[CONTRACT] Self identification",
}

export const contractGetIdentificationUrl = createAsyncThunk<
	IntesiLinkResponse | undefined,
	string,
	ThunkApiConfig
>(ContractReducer.getIdentificationUrl, async (type, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState().pratica.idPratica;

		if (!idPratica) return;

		let request: GetIdentificationUrlRequest = {
			idPratica,
			type,
		};

		return await new ContractApi(
			getConfiguration(Configuration, extra, getState)
		).getIdentificationUrl(request);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const contractIdentification = createAsyncThunk<
	IdentificationiResponseDto | undefined,
	void,
	ThunkApiConfig
>(ContractReducer.identification, async (_, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) throw new Error("idPratica non presente");

		let request: IdentificationRequest = {
			idPratica,
		};

		return await new ContractApi(getConfiguration(Configuration, extra, getState)).identification(
			request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const contractGenerateContracts = createAsyncThunk<
	FascicoloDto | undefined,
	void,
	ThunkApiConfig
>(ContractReducer.generateContracts, async (_, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) throw new Error("idPratica non presente");

		let request: GenerateContractRequest = {
			idPratica,
		};

		return await new ContractApi(getConfiguration(Configuration, extra, getState)).generateContract(
			request
		);
	} catch (e: any) {
		if ((e as any)?.response?.status === 400) {
			const decodeErrors = await decodeError(e.response);
			throw decodeErrors.message;
		} else errorHandler(e, dispatch);
	}
});

export const contractDownloadContract = createAsyncThunk<
	ContractDownloadDto | undefined,
	{ elencoIdAllegati: string[]; merged: boolean },
	ThunkApiConfig
>(
	ContractReducer.downloadContract,
	async ({ elencoIdAllegati, merged }, { dispatch, extra, getState }) => {
		try {
			let idPratica = getState()?.pratica?.idPratica;
			if (!idPratica) throw "ID Pratica non presente";

			let request: DownloadContractRequest = {
				downloadContractDto: {
					idPratica: Number(idPratica),
					elencoIdAllegati,
					merged,
				},
			};

			return await new ContractApi(getConfiguration(Configuration, extra, getState))
				.downloadContract(request)
				.then((res) => {
					if (res) {
						res?.contractList?.map((i) => {
							if (i?.content && i?.format) {
								FilesUtils.downloadFileBase64(i?.content, i?.fileName);
							}
						});
					}
					return res;
				});
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);

export const contractGetOtp = createAsyncThunk<
	IntesiPushOtpResponse | undefined,
	void,
	ThunkApiConfig
>(ContractReducer.downloadContract, async (_, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) throw new Error("idPratica non presente");

		let _request: PushOtp1Request = {
			idPratica,
		};

		return await new ContractApi(getConfiguration(Configuration, extra, getState)).pushOtp1(
			_request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const contractSignContract = createAsyncThunk<
	IntesiResponseDto | undefined,
	string,
	ThunkApiConfig
>(ContractReducer.signContract, async (otp, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) throw new Error("idPratica non presente");

		let _request: SignContractRequest = {
			idPratica,
			otp,
		};

		return await new ContractApi(getConfiguration(Configuration, extra, getState)).signContract(
			_request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const contractSumsubLogin = createAsyncThunk<
	SumsubTokenResponse | undefined,
	void,
	ThunkApiConfig
>(ContractReducer.sumsubLogin, async (_, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) throw new Error("idPratica non presente");

		let request: SelfLoginRequest = {
			idPratica,
		};

		return await new ContractApi(getConfiguration(Configuration, extra, getState)).selfLogin(
			request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});
